import React from 'react';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import TalentCard from '../../UIElements/TalentCard/TalentCard.mjs';
import { StyledTalentsCategoryLink, StyledHorizontalCarousel } from './Talents.styles.mjs';

const Talents = ({ items, href }) => (React.createElement(FlexContainer, { direction: "column", gap: "1.5rem" },
    React.createElement(StyledTalentsCategoryLink, { withMarker: true, withArrow: true, uppercased: true, href: href }, "Talents"),
    React.createElement(StyledHorizontalCarousel, null, items.map(item => (React.createElement(TalentCard, Object.assign({ key: item.id }, item)))))));

export { Talents as default };
//# sourceMappingURL=Talents.mjs.map
